// Observability shim — dependency-free, Sentry-pluggable.
//
// In production set VITE_SENTRY_DSN and load @sentry/react (see README) and this
// module will route through window.Sentry automatically. Without Sentry it logs
// to the console and, if VITE_ERROR_ENDPOINT is set, POSTs a JSON envelope there
// (e.g. a Cloudflare Worker or your own collector). Either way the app never
// crashes because the logger throws-free.

interface SentryLike {
  captureException?: (e: unknown, ctx?: Record<string, unknown>) => void
  captureMessage?: (m: string, ctx?: Record<string, unknown>) => void
  setUser?: (u: unknown) => void
}

function getSentry(): SentryLike | undefined {
  return (globalThis as any).Sentry as SentryLike | undefined
}

const ENDPOINT = import.meta.env.VITE_ERROR_ENDPOINT as string | undefined

export function captureException(error: unknown, context: Record<string, unknown> = {}) {
  const sentry = getSentry()
  if (sentry?.captureException) {
    sentry.captureException(error, context)
    return
  }
  console.error('[bitutravel]', error, context)
  if (ENDPOINT) {
    fetch(ENDPOINT, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        type: 'exception',
        message: error instanceof Error ? error.message : String(error),
        stack: error instanceof Error ? error.stack : undefined,
        context,
        at: new Date().toISOString(),
      }),
    }).catch(() => {})
  }
}

export function captureMessage(message: string, context: Record<string, unknown> = {}) {
  const sentry = getSentry()
  if (sentry?.captureMessage) {
    sentry.captureMessage(message, context)
    return
  }
  console.warn('[bitutravel]', message, context)
}